import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LanguageSelectorComponent]
})
export class HeaderComponent {
}
